/* src/app/private/components/roles/delete-role/delete-role.component.scss */
/*# sourceMappingURL=delete-role.component.css.map */
